<div class="banner-outer" [ngClass]="'banner-' + style" [class.banner-hidden]="hidden" [class.clickable]="canClick">
  <div class="banner-contents">
    <ng-content></ng-content>
  </div>

  <ng-container *ngIf="canDismiss">
    <app-table-action-icon (click)="onClickHide()" [icon]="'fa-times'" [hoverColor]="eIconHoverColor.RED" [tooltipText]="eCommonMessages.HIDE_BANNER" [tooltipPlacement]="'top'"></app-table-action-icon>
  </ng-container>
</div>